// @ts-strict-ignore
import {Injectable} from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class SimClientStorageService {
	/* -------------------------------------------- */
	// SESSION STORAGE
	/* -------------------------------------------- */

	public setSessionData(key: string, value: string) {
		if (window.sessionStorage) {
			window.sessionStorage.setItem(key, value);
		}
	}

	public getSessionData(key: string): string | null {
		if (window.sessionStorage) {
			return window.sessionStorage.getItem(key);
		} else {
			return null;
		}
	}

	public removeSessionData(key: string) {
		if (window.sessionStorage) {
			window.sessionStorage.removeItem(key);
		}
	}

	/* -------------------------------------------- */
	// LOCAL STORAGE
	/* -------------------------------------------- */

	public setLocalData(key: string, value: string) {
		if (window.localStorage) {
			window.localStorage.setItem(key, value);
		}
	}

	public getLocalData(key: string): string {
		if (window.localStorage) {
			return window.localStorage.getItem(key);
		} else {
			return null;
		}
	}

	public removeLocalData(key: string) {
		if (window.localStorage) {
			window.localStorage.removeItem(key);
		}
	}

	/* -------------------------------------------- */
	// GLOBAL TEMPORARY STORAGE
	/* -------------------------------------------- */

	private readonly storage = {};

	public setData<T>(key: string, value: T): void {
		this.storage[key] = value;
	}

	public getData<T>(key: string): T | null {
		return this.storage[key];
	}

	public removeData<T>(key: string) {
		delete this.storage[key];
	}
}
